export const gradeList = ['primary', 'secondary', 'adult'];